<template>
    <div id="contenedor-listado-sub-tipos-obras-mobiles">
        <template
            v-for="(subTipoObra, index) in listadoSubTiposObras">
            <v-card
                :key="index"
                class="mb-2">
                <v-card-title
                  class="justify-space-between">
                  <div
                    class="d-inline-block text-truncate">
                    {{ subTipoObra.descripcion }}
                  </div>
                </v-card-title>
                <v-card-text>
                </v-card-text>
            </v-card>
        </template>
    </div>
</template>

<script>
// import Opciones from './Opciones.vue';

export default {
  name: 'ListadoSubTiposObrasMobiles',
  props: {
    listadoSubTiposObras: {
      type: Array,
      required: true,
    },
  },
  components: {
    // Opciones,
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss">

</style>
